module.exports = __webpack_public_path__ + "img/EdStudent.d4539496.jpeg";